import { createEffect, createEvent, createStore, sample } from 'effector';
import type { TenantBranding } from '@buildex/module-contract';
import { saveTenantBranding } from '@/entities/tenant/api';
import { tenantBrandingSaved } from '@/entities/tenant/model';

/**
 * Черновик брендинга (§8): правки летят в превью через postMessage,
 * ничего не мутируют до «Сохранить» (PUT /api/admin/tenants/:id/branding).
 */

export const draftInitialized = createEvent<TenantBranding>();
export const draftChanged = createEvent<Partial<TenantBranding>>();
export const draftReset = createEvent<TenantBranding>();

export const $brandingDraft = createStore<TenantBranding | null>(null)
  .on(draftInitialized, (_, branding) => branding)
  .on(draftReset, (_, branding) => branding)
  .on(draftChanged, (draft, patch) => (draft === null ? draft : { ...draft, ...patch }));

export const brandingSaveSubmitted = createEvent<{ tenantId: string; branding: TenantBranding }>();

export const saveBrandingFx = createEffect<
  { tenantId: string; branding: TenantBranding },
  { tenantId: string; branding: TenantBranding },
  Error
>(({ tenantId, branding }) => saveTenantBranding(tenantId, branding));

export const $brandingSaving = saveBrandingFx.pending;

export const $brandingSaved = createStore<boolean>(false)
  .on(saveBrandingFx.done, () => true)
  .reset([brandingSaveSubmitted, draftChanged, draftInitialized]);

sample({ clock: brandingSaveSubmitted, target: saveBrandingFx });
sample({ clock: saveBrandingFx.doneData, target: tenantBrandingSaved });
